// test1741
(1741 && 0);
